import { useFormikContext } from 'formik'
import requests from 'service/api'
import AsyncSearchSelect from '../async-search-select'
import { asOptions, firstOption } from 'lib/asyncList'

export function SelectMadeIn({ name, brand }) {
  const { values } = useFormikContext()
  const isHome = brand === 'ZaraHome'
  const mapCountry = ({ id, name: label }) => ({ value: id, label })

  return (
    <AsyncSearchSelect
      label="Made In"
      name={name}
      value={values[name]}
      fetchSelected={(id) =>
        firstOption(isHome ? requests.country.getHome(id) : requests.country.get(id), mapCountry)
      }
      fetchOptions={(search) =>
        asOptions(
          isHome
            ? requests.country.listHome({ search, limit: 20 })
            : requests.country.list({ search, limit: 20 }),
          mapCountry
        )
      }
    />
  )
}
